let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("esUfm")), load("20nMe")]).then(() => parcelRequire('j5C3s'));